import { render, staticRenderFns } from "./MitHRDashboardPage.vue?vue&type=template&id=6be479c2&scoped=true"
import script from "./MitHRDashboardPage.vue?vue&type=script&lang=js"
export * from "./MitHRDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./MitHRDashboardPage.vue?vue&type=style&index=0&id=6be479c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be479c2",
  null
  
)

export default component.exports